// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1wreJ","footer":"ModalCreateQualiphyProcedure_footer__4ULsP","additionData":"ModalCreateQualiphyProcedure_additionData__3ETNs"};